import React, { useState } from 'react';
import './UpdatesPage.css';
import Header from '../../components/Header/Header';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';

/* ── Replace with real events when mam provides ── */
const EVENTS = {
  seasonal: [
    { title: 'Canada Summer Camp 2026', date: 'July 6 – Aug 28, 2026', status: 'Open', location: 'Alberta, Canada', desc: 'Hands-on robotics camp for children aged 6 and above. Multiple weekly batches. Kit included.', tag: 'Summer Camp' },
    { title: 'Summer Camp — Event Name', date: 'Date TBD', status: 'Upcoming', location: 'Coimbatore', desc: 'Description will be added here once mam provides the details for this seasonal programme.', tag: 'Seasonal' },
  ],
  camps: [
    { title: 'Camp Name Here', date: 'Date TBD', status: 'Upcoming', location: 'Location TBD', desc: 'Camp description will be added here once details are provided.', tag: 'Camp' },
    { title: 'Camp Name Here', date: 'Date TBD', status: 'Upcoming', location: 'Location TBD', desc: 'Camp description will be added here once details are provided.', tag: 'Camp' },
  ],
  hackathons: [
    { title: 'ibots Spark 1.0', date: 'July 2026', status: 'Open', location: 'Coimbatore', desc: 'National School Hardware Hackathon Series — for students aged 8 and above. Three categories: 8–10, 11–13, 14+.', tag: 'Hackathon' },
    { title: 'Hackathon Event Name', date: 'Date TBD', status: 'Upcoming', location: 'Location TBD', desc: 'Hackathon description will be added here once details are provided.', tag: 'Hackathon' },
  ],
};

const TABS = [
  { key: 'seasonal',   label: 'Seasonal Programmes' },
  { key: 'camps',      label: 'Camps' },
  { key: 'hackathons', label: 'Hackathons' },
];

const STATUS_STYLE = {
  'Open':     { bg: '#dcfce7', color: '#166534' },
  'Upcoming': { bg: '#fef3c7', color: '#92400e' },
  'Closed':   { bg: '#f1f5f9', color: '#64748b' },
};

function UpdatesPage() {
  const [activeTab, setActiveTab] = useState('seasonal');

  return (
    <div className="up__page">
      <Header />
      <Navbar />

      {/* Hero */}
      <div className="up__hero">
        <p className="up__hero-eyebrow">Latest from ibots</p>
        <h1 className="up__hero-title">Events & Updates</h1>
        <p className="up__hero-sub">Stay updated on seasonal programmes, camps and hackathon events from ibots.</p>
      </div>

      {/* Tabs */}
      <div className="up__tabs-wrap">
        <div className="up__tabs">
          {TABS.map(t => (
            <button key={t.key}
              className={`up__tab ${activeTab === t.key ? 'up__tab--active' : ''}`}
              onClick={() => setActiveTab(t.key)}>
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {/* Cards */}
      <div className="up__content">
        <div className="up__grid">
          {EVENTS[activeTab].map((e, i) => (
            <div key={i} className="up__card">
              <div className="up__card-top">
                <span className="up__card-tag">{e.tag}</span>
                <span className="up__card-status" style={{ background: STATUS_STYLE[e.status]?.bg, color: STATUS_STYLE[e.status]?.color }}>
                  {e.status}
                </span>
              </div>
              <h3 className="up__card-title">{e.title}</h3>
              <div className="up__card-meta">
                <span className="up__meta-item">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                  {e.date}
                </span>
                <span className="up__meta-item">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                  {e.location}
                </span>
              </div>
              <p className="up__card-desc">{e.desc}</p>
              <button className="up__card-btn">Know More →</button>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default UpdatesPage;
